import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registration: {
    status: "idle",
    error: null,
  },
  login:{
    loginstatus:false,
    userfullname:"",
    useremail:"",
    userid:"",
    token:''
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    registerStart(state) {
      state.registration.status = "loading";
      state.registration.error = null;
    },
    registerSuccess(state) {
      state.registration.status = "succeeded";
      state.registration.error = null;
    },
    registerFailure(state, action) {
      state.registration.status = "failed";
      state.registration.error = action.payload || "Registration failed";
    },
    resetRegistration(state) {
      state.registration.status = "idle";
      state.registration.error = null;
    },
    loginSuccess(state, action) {
      state.login.loginstatus = true;
      state.login.userfullname = action.payload.userfullname;
      state.login.useremail = action.payload.useremail;
      state.login.userid = action.payload.userid;
      state.login.token = action.payload.token;
    },
    logout(state) {
      state.login.loginstatus = false;
      state.login.userfullname = "";
      state.login.useremail = "";
      state.login.userid = "";
      state.login.token = "";
    },
  },
});

export const {
  registerStart,
  registerSuccess,
  registerFailure,
  resetRegistration,
  loginSuccess,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
